import {
  GET_MERCHANTS_FAILD,
  GET_MERCHANTS_LOADING,
  GET_MERCHANTS_SUCCESS,
  RESET_MERCHANT_LIST
} from "../types";

const initialState = {
  loading: false,
  error: null,
  merchants: null,
};

export const getMerchantsReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any }
) => {
  switch (action.type) {
    case GET_MERCHANTS_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case GET_MERCHANTS_SUCCESS:
      return {
        ...state,
        loading: false,
        merchants: action.payload,
        error: null,
      };
    case GET_MERCHANTS_FAILD:
      return {
        ...state,
        loading: false,
        merchants: null,
        error: action.error,
      };
    case RESET_MERCHANT_LIST:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
